






import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import MarkDown from '@/apps/open/views/fileCenter/components/MarkDown.vue'

import axios from 'axios'
@Component({
  components: {
    MarkDown
  }
})
export default class FileContent extends Vue {
    content = ''

    get isPrivate () {
      return this.$store.getters['isPrivate']
    }

    get isPriDocMiddle () {
      return this.$store.getters['isPriDocMiddle']
    }

    beforeRouteEnter (to: any, from: any, next: any) {
      next((vm: any) => {
        if (to.path === '/docs/wwo/access/jssdk-import') {
          window.open('https://wwo.wps.cn/docs-js-sdk', '_blank')
          vm.$router.go(-1)
        } else {
          vm.initFileContent(to)
        }
      })
    }

    initFileContent (curRoute: any) {
      let mdfileUrl: string = `/mdfile/${this.isPrivate ? this.isPriDocMiddle ? 'middle' : 'pri_filecenter' : 'filecenter'}` + curRoute.meta.mdfilepath
      axios.get(mdfileUrl).then(response => {
        this.content = response.data
        !this.isPrivate && setTimeout(() => {
          this.initScrollPosition()
        })
      })
    }

    initScrollPosition () {
      if (location.hash) {
        const scrollId: string = location.hash
        const toScrollDom: Element | null = document.querySelector(scrollId)
        toScrollDom && window.scroll(0, window.scrollY + toScrollDom.getBoundingClientRect().top - 200)
      }
    }
}
